import * as React from 'react'
import classNames from 'classnames'

import style from './style.scss'

type Props = {
  children: string
  className?: string
}

BucketBadge.defaultProps = {
  className: '',
}

function BucketBadge(props: Props) {
  const { children, className } = props

  return (
    <span className={classNames(style.wrapper, className)}>{children}</span>
  )
}

export default BucketBadge
